import React from 'react'
import { Link } from 'react-router-dom'

import style from './Breadcrumbs.module.scss'
import { BreadcrumbsType } from './Breadcrumbs.types'

function Breadcrumbs({ arrayLinks, classModifiers }: BreadcrumbsType) {
  const classList: string[] = classModifiers
    ? classModifiers.map((el: string) => `${style['Breadcrumbs--' + el]}`)
    : []

  return (
    <div className={`${style.Breadcrumbs} ${classList?.join(' ')}`}>
      {arrayLinks.map((link, index) => {
        if (arrayLinks.length !== index + 1) {
          return (
            // <Link className={style.Breadcrumbs__link} to={link.url} key={index}>
            //   {link.name}
            // </Link>
            <div className={style.Breadcrumbs__link} key={index}>
              {link.name}
            </div>
          )
        } else {
          return (
            <div className={style.Breadcrumbs__link} key={index}>
              {link.name}
            </div>
          )
        }
      })}
    </div>
  )
}

export default Breadcrumbs
